// extracted by mini-css-extract-plugin
export default {"Heading__xxl":"gPvktb","headingXxl":"gPvktb","Heading__xxxl":"rxnTCG","headingXxxl":"rxnTCG","Heading__fontWeightNormal":"FPt0iU","headingFontWeightNormal":"FPt0iU"};